<template>
  <div class="wr-dashboard">
    <el-container class="wr-dashboard-el-container">
      <el-container class="wr-dashboard-el-container">
        <el-header :bordered="true">
          <span
            slot="aside"
            class="centered wr-el-header-container"
          >

            <el-row class="wr-dashboard-el-header">
              <el-col
                :span="16"
                class="wr-dashboard-el-header"
              >

                <span
                  class="el-text el-text--body-24 ml-8"
                  v-if="!isBreadCrumbsVisible">
                  {{ $t('wr-dashboard.breadcrumb.item.machines') }}
                </span>


                <content-table-breadcrumbs
                  :menu-item-id="'machines-table'"
                  :menu-item-display-name="$t('wr-dashboard.breadcrumb.item.machines')"
                  :machine-id="getActiveMachineId"
                  :machine-display-name="getActiveMachineDisplayName"
                  :archive-id="getActiveBackupId"
                  :archive-display-name="getActiveBackupDisplayName"
                  :is-visible="isBreadCrumbsVisible"
                  @breadcrumbItemClick="handleBreadcrumbItemClick"
                />

                &nbsp;
              </el-col>

              <el-col
                :span="6"
                class="wr-dashboard-el-header"
                style="text-align: right; padding: 0;">
                <el-input
                  v-if="isSearchInputVisible"
                  v-model="searchInputValue"
                  class="mx-16 wr-dashboard-el-header-search-input"
                  value=""
                  :placeholder="$t('wr-dashboard.search.input.hint')"
                  suffix-icon="i-search-o--16"
                  size="small"
                  @change="onSearchInputChange"
                  :on-icon-click="onSearchInputIconClick"
                  :disabled="isTableDataLoading"
                  autofocus
                />
              </el-col>


              <el-col
                :span="1"
                class="wr-dashboard-el-header"
                style="text-align: right; padding: 0;">
                <el-button
                  v-if="getSearchEnabled && !isSearchInputVisible"
                  class="wr-dashboard-el-header-button"
                  type="text"
                  @click="searchButtonClick">
                  <el-icon
                    color="brand-primary"
                    name="i-search-o--24"
                  />
                </el-button>
              </el-col>

              <el-col
                :span="1"
                class="wr-dashboard-el-header"
                style="text-align: right; padding-right: 8px;">
                <el-dropdown
                  placement="bottom-end"
                  @command="handleUserMenuDropdownItemClick">
                  <el-button
                    type="text"
                    class="wr-dashboard-el-header-button">
                    <el-icon
                      color="brand-primary"
                      name="i-user-circle-o--24"
                    />
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        disabled
                        style="color: black;">
                        {{ getDisplayUserName }}
                      </el-dropdown-item>
                      <el-dropdown-item command="logout">
                        {{ $t('wr-dashboard.account-menu.action.sign-out') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </el-col>

            </el-row>

          </span>
        </el-header>

        <el-main class="el-main-container">

          <machines-table
            v-if="isActiveMachinesTable"
            @machineSelected="handleMachineSelected"
          />

          <machine-backups-table
            v-if="isActiveMachineBackupsTable"
            @boxSelected="handleBackupSelected"
          />

          <incomplete-backups-table
            v-if="isActiveIncompleteBackupsTable"
          />

          <content-table
            v-if="isActiveContentTable"
            :content-list="getContentItems"
            :archive-id="selectedBox.id"
            :box-type="selectedBox.type"
            :box-group="selectedBox.group"
            :status-column-hidden="statusColumnHidden"
            :path-column-hidden="!getSearchResultReceived"
            :search-value="searchInputValue"
            @folderSelected="loadContent"
          />

          <delete-incomplete-archives-dialog-box
            v-if="deleteIncompleteDialogBoxVisible"
            @handleClose="handleIncompleteDeleteClose"
          />

        </el-main>

        <el-footer
          class="wr-dashboard-footer px-24"
          v-if="isIncompleteBackupsFooterControlVisible">

          <el-row
            type="flex"
            align="middle"
            class="wr-dashboard-footer-row">
            <el-col
              :span="14"
              style="text-align: left; padding: 0;"
            >
              <el-icon
                style="margin-top: -2px;"
                color="brand-primary"
                name="i-exclamation-circle--16"
              />
              &nbsp;
              <span class="el-text el-text--body-24">
                {{ $tc('wr-dashboard.incomplete-backups.message.status:plural',
                       getIncompleteBackupsCount,
                       {count: getIncompleteBackupsCount, size: icmSizeText})
                }}
              </span>
            </el-col>


            <el-col
              :span="10"
              style="text-align: right; padding: 0;">

              <el-button
                type="text"
                @click="goToIncompleteBackupsTable"
              >
                {{ $t('wr-dashboard.incomplete-backups.button.view') }}
              </el-button>

              <el-button
                type="text"
                @click="showDeleteAllIncompleteConfirmation"
              >
                {{ $t('wr-dashboard.incomplete-backups.button.delete') }}
              </el-button>
            </el-col>


          </el-row>


        </el-footer>

      </el-container>
    </el-container>

    <router-view />
  </div>
</template>

<style lang="scss" scoped>
  $wr-sp-indicator-block-height: 160px;
  $wr-default-elements-padding: 16px;

  .wr-dashboard-el-header {
    height: 64px;
    line-height: 64px;
  }

  .wr-dashboard-el-header-search-input {
    text-align: left;
    max-width: 267px;
    line-height: 32px;
    height: 32px;
    margin-top: 19px;
  }

  .wr-dashboard-el-header-button {
    line-height: 24px;
    height: 24px;
    width: 24px;
  }

  .wr-dashboard-el-container {
    height: 100vh;
  }

  .el-header, .el-footer, .el-main {
    background-color: $av-fixed-white;
  }

  .wr-dashboard-nav-menu {
    height: calc(100vh - #{$wr-sp-indicator-block-height});
  }

  .wr-dashboard-space-indicator {
    padding: $wr-default-elements-padding;
    height: $wr-sp-indicator-block-height;
  }

  .el-header {
    position: relative;
    line-height: calc(#{$wr-default-elements-padding} * 4);
  }

  .wr-el-header-container {
    padding-left: $wr-default-elements-padding;
    padding-right: $wr-default-elements-padding;
  }

  .el-aside {
    background-color: $av-nav-primary;
    color: $av-fixed-primary;
  }

  .centered {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .wr-dashboard-footer {
    z-index: 5000;
    height: 64px;
    background-color: $av-brand-lightest;
    text-align: center;
  }
  .wr-dashboard-footer-row {
    height: 64px;
  }

</style>

<script>
import { createNamespacedHelpers } from 'vuex';

import { AUTH_LOGOUT } from '@/app/store/action-types';
import MachineBackupsTable from './MachineBackupsTable';
import PasswordDialogBox from './PasswordDialogBox';
import ContentTable from './ContentTable';
import ContentTableBreadcrumbs from './ContentTableBreadcrumbs';
import MachinesTable from './MachinesTable';
import IncompleteBackupsTable from './IncompleteBackupsTable';
import DeleteIncompleteArchivesDialogBox from './DeleteIncompleteArchivesDialogBox';

import {
  PENDING_STATUS
} from '../store/action-status';

import {
  FETCH_STORAGE_SPACE,
  FETCH_CONTENT_ITEMS,
  SEARCH_CONTENT_ITEMS,
  UPDATE_ACTIVE_CONTENT_TYPE,
  FETCH_WR_CONFIG,
  UPDATE_ACTIVE_MACHINE
} from '../store/action-types';

import {
  MACHINE_TABLE_TYPE,
  BACKUP_TABLE_TYPE,
  INCOMPLETE_BACKUP_TABLE_TYPE,
  CONTENT_TABLE_TYPE
} from '../store/active-content-type';

const { mapGetters, mapActions } = createNamespacedHelpers('wr-dashboard');

export default {
  name: 'WrDashboard',
  components: {
    MachineBackupsTable,
    PasswordDialogBox,
    ContentTable,
    ContentTableBreadcrumbs,
    MachinesTable,
    IncompleteBackupsTable,
    DeleteIncompleteArchivesDialogBox
  },
  data: function () {
    return {
      selectedBox: { id: '', type: 'BACKUP', displayName: '' },
      selectedMachine: { subAccountId: 0, displayName: '' },
      fullScreenLoader: '',
      isFullScreenLoaderActive: false,
      passwordDialogBoxVisible: false,
      passwordDialogBoxBox: '',
      statusColumnHidden: false,
      isSearchInputVisible: false,
      searchInputValue: '',
      deleteIncompleteDialogBoxVisible: false
    };
  },
  computed: {
    ...mapGetters([
      'getContentItems',
      'getStorageSpace',
      'getFetchContentItemsStatus',
      'getActiveContentType',
      'getIncompleteBackupsCount',
      'getIncompleteBackupsSize',
      'getBackups',
      'getSearchEnabled',
      'getSearchResultReceived',
      'getActiveVolumePath',
      'getActiveFolderItem',
      'getActiveMachineId',
      'getActiveMachineDisplayName',
      'getActiveBackupId',
      'getActiveBackupDisplayName',
      'getIncompleteBackupsMachineId',
      'getDisplayUserName'
    ]),
    isTableDataLoading() {
      return this.getFetchContentItemsStatus === PENDING_STATUS;
    },
    isIncompleteBackupsFooterControlVisible() {
      return !this.deleteIncompleteDialogBoxVisible &&
        this.isActiveMachinesTable &&
        this.getIncompleteBackupsCount > 0;
    },
    icmSizeText() {
      return this.$options.filters.size(this.getIncompleteBackupsSize);
    },
    isActiveMachinesTable() {
      return this.getActiveContentType === MACHINE_TABLE_TYPE;
    },
    isActiveMachineBackupsTable() {
      return this.getActiveContentType === BACKUP_TABLE_TYPE;
    },
    isActiveIncompleteBackupsTable() {
      return this.getActiveContentType === INCOMPLETE_BACKUP_TABLE_TYPE;
    },
    isActiveContentTable() {
      return this.getActiveContentType === CONTENT_TABLE_TYPE;
    },
    isBreadCrumbsVisible() {
      return this.getActiveContentType === BACKUP_TABLE_TYPE
          || this.getActiveContentType === CONTENT_TABLE_TYPE
          || this.getActiveContentType === INCOMPLETE_BACKUP_TABLE_TYPE;
    }
  },
  watch: {
    getSearchEnabled(enabled) {
      if (!enabled) {
        this.isSearchInputVisible = false;
        this.searchInputValue = '';
      }
    }
  },
  methods: {
    ...mapActions({
      fetchStorageSpace: FETCH_STORAGE_SPACE,
      fetchContentItems: FETCH_CONTENT_ITEMS,
      searchContentItems: SEARCH_CONTENT_ITEMS,
      updateActiveContentType: UPDATE_ACTIVE_CONTENT_TYPE,
      fetchWrConfig: FETCH_WR_CONFIG,
      updateActiveMachine: UPDATE_ACTIVE_MACHINE
    }),
    goToIncompleteBackupsTable() {
      this.updateActiveMachine({
        machineId: this.getIncompleteBackupsMachineId,
        displayName: this.$t('wr-dashboard.breadcrumb.item.failed-backups')
      });
      this.updateActiveContentType(INCOMPLETE_BACKUP_TABLE_TYPE);
    },
    showDeleteAllIncompleteConfirmation() {
      this.deleteIncompleteDialogBoxVisible = true;
    },
    handleIncompleteDeleteClose() {
      this.deleteIncompleteDialogBoxVisible = false;
    },
    handleMachineSelected(machineId) {
      if (machineId === this.getIncompleteBackupsMachineId) {
        this.goToIncompleteBackupsTable();
      } else {
        this.updateActiveContentType(BACKUP_TABLE_TYPE);
      }
    },
    init() {
      this.fetchWrConfig();
      // this.fetchStorageSpace();
    },
    handleUserMenuDropdownItemClick(command) {
      if (command === 'logout') {
        this.$store.dispatch(AUTH_LOGOUT);
        window.open(window.location.origin, '_self');
      }
    },
    searchButtonClick() {
      this.isSearchInputVisible = true;
    },
    handleBackupSelected(selectedItem) {
      this.updateActiveContentType(CONTENT_TABLE_TYPE);
      this.selectedBox = this.getSelectedBox(selectedItem.boxId);
      // this.statusColumnHidden = !this.selectedBox.options.notarized;

      this.loadContent({
        archiveId: selectedItem.boxId,
        path: ''
      });
    },
    handleBreadcrumbItemClick(selectedItem) {
      if (selectedItem.menuItem !== undefined) {
        this.updateActiveContentType(MACHINE_TABLE_TYPE);
      } else if (selectedItem.machineId !== undefined) {
        this.handleMachineSelected(selectedItem.machineId);
      } else if (selectedItem.isSearchFolder === true) {
        this.onSearchInputChange(selectedItem.crumbTitle);
      } else {
        this.loadContent(selectedItem);
      }
    },
    loadContent(selectedItem) {
      this.fetchContentItems(selectedItem);
    },
    getSelectedBox(boxId) {
      return this.getBackups.filter(obj => obj.id === boxId)[0];
    },
    onSearchInputIconClick() {
      this.onSearchInputChange(this.searchInputValue);
    },
    onSearchInputChange(value) {
      if (value !== '') {
        this.searchContentItems({
          archiveId: this.selectedBox.id,
          volumePath: this.getActiveVolumePath,
          path: this.getActiveFolderItem.path,
          searchText: value
        });
      }
    }
  },
  async created() {
    await this.init();
  }
};
</script>
